// extracted by mini-css-extract-plugin
module.exports = {"root":"ChatPanelHeader_root__0irlv","title":"ChatPanelHeader_title__TWu0m"};